<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#757575', color: '#ffffff' }"
    class="ml-3"
    @click="performAction"
  >
    <i class="fa fa-archive" />
    Complete
  </b-button>
</template>

<script lang="ts">
import { notify } from '@kyvg/vue3-notification'
import { BButton } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'
import { openModal } from '@/services/Modal'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'

export default defineComponent({
  name: 'Complete',
  components: { BButton },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const performAction = () => {
      openModal('confirmWrap', {
        title: 'Complete the assignment?',
        message: 'This will mark the assignment as complete',
        onConfirm: () => {
          assignmentSummaryStore.submitComplete().then(() => {
            notify({ group: 'success', text: 'Assignment was completed' })
          })
        },
      })
    }

    return {
      performAction,
    }
  },
})
</script>
